import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import api from '@/api/api-config'

import paperBank from './modules/paper-bank'
import other from './modules/other'
import search from './modules/search'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },{
    path: '*',
    name: 'error',
    component: HomeView,
  },
  ...other,
  ...search,
  ...paperBank,
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to,from,savedPosition){
    if (savedPosition){
      // 按下 后退/前进 按钮时，类似浏览器的原生表现
      return savedPosition
    }else {
      // 让页面滚动到顶部
      return {
        x: 0,
        y: 0
      } 
    }  
  }
})

router.beforeEach((to, from, next)=>{
  if(to.meta.requiresAuth){
    const token = localStorage.getItem('token')
    
    if(token){
      api({
        method: 'post',
        url: '/verifyToken',
        headers: {
          authorization: token
        }
      }).then(res => {
        if(res.data == null){
          localStorage.clear()
          next('/topic-bank')
        } 
       })
      // eslint-disable-next-line
      .catch(err => {
        next('/topic-bank') 
      })
    } else {
      next('/topic-bank')
    }
  } 

  next()
})

export default router
